import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import myImage from "../../assets/logo-parish.png";
export default function Home() {
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} sm={6} md={6}>
        <Card>
          <CardHeader
            title="Zgharta App Control Panel"
            style={{ alignItems: "center", textAlign: "center" }}
          />
          <CardContent>
            {" "}
            <Grid item>
              <img
                src={myImage}
                alt=""
                style={{
                  maxWidth: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                }}
              />
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
